import { render, staticRenderFns } from "./InventoryLabResultIndex.vue?vue&type=template&id=685a9a51"
import script from "./InventoryLabResultIndex.vue?vue&type=script&lang=js"
export * from "./InventoryLabResultIndex.vue?vue&type=script&lang=js"
import style0 from "./InventoryLabResultIndex.vue?vue&type=style&index=0&id=685a9a51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports